import React, { useCallback, useEffect, useRef, useState } from "react";
import { usePmsTheme } from "../../../Components/PmsThemeContext";
import { ocrDistributorTranslator } from "./ocrDistributorMessages";

// Resolve the commercial supplier in the background; catalogue management lives
// in the supplier form. Successful recognition adds no separate OCR interface.
export default function OcrDistributorPanel({ importId, scopedApi, disabled, onResolution, onReadyChange, resolvePath, checkCatalogue = true }) {
  const { languageId } = usePmsTheme();
  const t = ocrDistributorTranslator(languageId);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const latest = useRef({ onResolution, onReadyChange });
  latest.current = { onResolution, onReadyChange };
  const requestId = useRef(0);

  const load = useCallback(async () => {
    const request = ++requestId.current;
    setLoading(true); setError(false);
    latest.current.onReadyChange(false);
    try {
      if (checkCatalogue) {
        const { data: catalogue } = await scopedApi.get("/api/purchasing/distributors/options");
        if (request !== requestId.current) return;
        if (!Array.isArray(catalogue)) throw new Error("Invalid distributor catalogue");
      }
      // Learned supplier aliases also apply when there are no distributors.
      const { data } = await scopedApi.post(resolvePath || `/api/purchasing/ocr-imports/${importId}/resolve-supplier`, {});
      if (request !== requestId.current) return;
      if (!Array.isArray(data?.supplier_candidates)) throw new Error("Invalid supplier resolution");
      latest.current.onResolution(data);
      latest.current.onReadyChange(true);
    } catch {
      if (request === requestId.current) setError(true);
    } finally {
      if (request === requestId.current) setLoading(false);
    }
  }, [importId, scopedApi, resolvePath, checkCatalogue]);

  useEffect(() => { load(); return () => { requestId.current += 1; }; }, [load]);

  if (!error) return null;
  return <div className="ocrp-alert ocrp-alert--error" role="alert">
    {t("Could not identify the supplier. Try again.")}
    <button type="button" className="ocrp-btn" disabled={disabled || loading} onClick={load}>{t("Retry")}</button>
  </div>;
}
